module.exports = __webpack_public_path__ + "img/img18.eeaf7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img18.png
// module id = 56
// module chunks = 0